module.exports = __webpack_public_path__ + "img/Carousel-Beneficios-icono-10.ef1f23fc.svg";